import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Chat from "./pages/Chat/Chat.jsx";
import Login from "./pages/Login/Login.jsx";
import { EventEmitterProvider } from "./contexts/EventEmmiter.js";
import ProtectedRoute from "./services/AuthGaurd.jsx";
import store from "./store/index.js";
import { Provider } from "react-redux";
// import SessionExpiration from "./services/SessionExpiration.jsx";

function App() {
  return (
    <div
      style={{
        margin: "0",
        padding: "0",
        width: "100%",
        height: "100%",
      }}
    >
      <EventEmitterProvider>
        <Provider store={store}>
          <Router>
            {/* <SessionExpiration> */}
              <Routes>
                <Route
                  path="dashboard"
                  element={<ProtectedRoute element={Chat} />}
                />
                <Route
                  path="chat"
                  element={<ProtectedRoute element={Chat} />}
                />
                <Route
                  path="sign-in"
                  element={<Login/>}
                />
                <Route path="*" element={<Navigate to="sign-in" />} />
              </Routes>
            {/* </SessionExpiration> */}
          </Router>
        </Provider>
      </EventEmitterProvider>
    </div>
  );
}

export default App;